import React, { useEffect, useState } from 'react';
import Image from '../Image';
import { Link } from 'react-router-dom';

function HomeIssues() {
  const [latestIssues, setLatestIssues] = useState([]);

  useEffect(() => {
    fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllIssues')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          // Filter published only and get latest 4
          const publishedIssues = data.issues
            .filter(issue => issue.publish === 1)
            .slice(0, 4); // Assuming issues are ordered DESC by ID

          setLatestIssues(publishedIssues);
        }
      })
      .catch(err => console.error('Failed to fetch issues:', err));
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month.toUpperCase()} ${year}`;
  };

  return (
    <div className='homeiss_section'>
      <div className='homeiss_wrapper'>

        <div className="section_hr"></div>
        <p className='section_title'>Previous Issues</p>

        <div className='homeiss_cover_wrapper'>
          {latestIssues.map((issue) => (
            <div className='homeiss_cover' key={issue.id}>
              <div className='homeiss_image_block'>
                <Link className='hao_link' to={`/articles?issue=${issue.id}`}>
                  <Image src={issue.image} alt="Annals of Nursing Cover" class="homeiss_image" />
                </Link>
              </div>
              <div className="homeiss_data">
                <p className='homeiss_date'>
                  {formatDate(issue.date)}
                </p>
                <p className='homeiss_volno'>
                  {issue.title}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className='homeiss_all_issues'>
          <div className='ann_link_wrapper'>
            <Link to="archive" className='ann_link'>
              View All Issues&nbsp;&nbsp;<span className="fa-solid fa-angle-right"></span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeIssues;